import Vue from 'vue'
import VueGtag from "vue-gtag"
import App from './App.vue'
import router from './router'
import store from './store'
import firebase from "firebase/app";
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";
import { CaptureConsole as CaptureConsoleIntegration } from "@sentry/integrations";
import vuetify from './plugins/vuetify'
import './assets/sass/style.scss'
// i18nのインポート
import VueI18n from 'vue-i18n'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import '@mdi/font/css/materialdesignicons.css'
import Quill from 'quill'
import ResizeModule from "@ssumo/quill-resize-module";
const main = async () => {
Quill.register('modules/resize', ResizeModule)
Vue.use(VueI18n)
Vue.use(VueQuillEditor)
Vue.config.productionTip = false

const hostName = window.location.hostname
const isProduction = hostName.endsWith(".liqlid.jp") && !hostName.endsWith("ver2-test.liqlid.jp")

if (window.location.port !== "8080") {
  Sentry.init({
    Vue,
    // environmentは、〜.liqlid.jpで終わっていればproduction, 〜.netlify.appであればstaging, それ以外はdevelopmentとなる
    environment: isProduction ? "production" :hostName.endsWith(".netlify.app") ? "staging" : "development",
    dsn: isProduction ? process.env.VUE_APP_SENTRY_DSN : process.env.VUE_APP_SENTRY_DSN_DEV,

    // 開発では全てのセッションをサンプリングし、プロダクション環境ではエラーが発生しない限り10%のみサンプリングする
    replaysSessionSampleRate: isProduction ? 0.1 : 1.0,
    replaysOnErrorSampleRate: 1.0,

    integrations: [
      new Sentry.Replay(),
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracePropagationTargets: ["localhost", /^\//],
      }),
      new CaptureConsoleIntegration({
        levels: ["error", "warn"],
      }),
    ],
    ignoreErrors: [
      /Firebase Storage: Object '.*.html' does not exist. \(storage\/object-not-found\)/,
      /Firebase Storage: Object '.*.pdf' does not exist. \(storage\/object-not-found\)/,
    ],
    tracesSampleRate: 1.0,
  });
}
const firebaseConfigJSONString = process.env.VUE_APP_FIREBASE_CONFIG_JSON || "";
const firebaseConfig = JSON.parse(firebaseConfigJSONString);
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

// この設定を有効にすると、SDKのネットワークトランスポート（WebChannel）がロングポーリングを使用するように強制されます。 レスポンスは、デフォルトではバックエンドがデータを送信した後すぐに閉じられます（バックエンドがさらにデータを送信する可能性があるため、レスポンスは開いたままになります）。 これにより、間違ってトラフィックを無期限にバッファリングするようなプロキシ、アンチウイルスソフトウェアなどの一部のソフトウェアとの互換性の問題を回避できます。 このオプションを使用すると、パフォーマンスが低下する可能性があります。
// https://firebase.google.com/docs/reference/js/v8/firebase.firestore.Settings#optional-experimentalforcelongpolling
// firebase.firestore().settings({ experimentalForceLongPolling: true })
firebase.firestore().settings({ experimentalAutoDetectLongPolling: true, merge: true });

firebase.functions().region = "asia-northeast1";  // Realtime Databaseはus-central1にしかないので注意
const isEmulating = false; // make true if you want to test with local emulator
if (isEmulating && !isProduction) {
  firebase.auth().useEmulator("http://localhost:9099");
  firebase.firestore().useEmulator("localhost", 8090);
  firebase.storage().useEmulator("localhost", 9199);
  firebase.functions().useEmulator("localhost", 5002);
}

// i18nの設定
const messagesJSONString = (await firebase.firestore().doc("/initial/i18n").get()).data()?.ja || "{}"
const messages = JSON.parse(messagesJSONString)
const i18n = new VueI18n({
  locale: 'ja',
  messages,
  silentFallbackWarn: true,
  silentTranslationWarn: true
});

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')

// 存在しなければ何もしない
const firebaseId = process.env.VUE_APP_FIREBASE_ID || "";
if (firebaseId) {
  Vue.use(
    VueGtag,
    {
      config: {
        id: firebaseId,
      },
    },
    router
  );
}
}

main()